export const ORDER_STATUS_OPEN = 1;
export const ORDER_STATUS_COMPLETED = 7;
export const ORDER_STATUS_CANCELED = 8;